// Page scripting for Warframe list and single Warframe pages

// List page
if (document.getElementById('warframe-list')) {
    const MastheadVideos = document.querySelectorAll('.MastheadBackground-video');
    const MastheadPanels = document.querySelectorAll('.MastheadPanel');
    let currentIndex = 0;

    const MastheadToggles = document.querySelectorAll('.MastheadPanel-next');
    MastheadToggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.stopPropagation();

            currentIndex++;
            if (currentIndex >= MastheadPanels.length) currentIndex = 0;

            MastheadVideos.forEach(
                (element, i) => element.classList.toggle('is-active', i === currentIndex)
            );
            MastheadPanels.forEach(
                (element, i) => element.classList.toggle('is-active', i === currentIndex)
            );
        });
    });
}

if (document.getElementById("warframe-single")) {
    const MastheadVideos = document.querySelectorAll('.MastheadBackground-video');
    const MastheadPanels = document.querySelectorAll('.MastheadPanel');
    const WarframeStats = document.querySelectorAll('.WarframeStatBlock');
    const OverlapPanel = document.querySelector('.OverlapPanel');
    const WarframeAbilityGrid = document.querySelector('.WarframeAbilityGrid');
    let initialMastheadIndex = 0;
    let activeMastheadIndex = 0;

    MastheadPanels.forEach((panel, index) => {
        if (panel.classList.contains('is-active')) {
            initialMastheadIndex = index;
            activeMastheadIndex = index;
            OverlapPanel.classList.toggle('is-prime', index === 1);
            WarframeAbilityGrid.classList.toggle('is-prime', index === 1);
        }
    });

    function syncMasthead(index) {
        if (activeMastheadIndex !== index) {
            activeMastheadIndex = index;
            MastheadVideos.forEach((elem, i) => elem.classList.toggle('is-active', index === i));
            MastheadPanels.forEach((elem, i) => elem.classList.toggle('is-active', index === i));
            WarframeStats.forEach((elem, i) => elem.classList.toggle('is-active', index === i));
            OverlapPanel.classList.toggle('is-prime', index === 1);
            WarframeAbilityGrid.classList.toggle('is-prime', index === 1);
        }
    }
    function updateHistory(index) {
        if (activeMastheadIndex !== index) {
            history.pushState(
                {mastheadIndex: index},
                "",
                new URL(MastheadPanels[index].getAttribute('data-url'))
            );
        }
    }
    window.addEventListener('popstate', (e) => {
       if (e && e.state) {
           syncMasthead(e.state.mastheadIndex);
       } else {
           syncMasthead(initialMastheadIndex);
       }
    });

    const RegularButtons = document.querySelectorAll('.Button.MastheadPanel-base');
    const PrimeButtons = document.querySelectorAll('.Button.MastheadPanel-prime');
    RegularButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            updateHistory(0);
            syncMasthead(0);
        });
    });
    PrimeButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            updateHistory(1);
            syncMasthead(1);
        });
    });
}

// Ability selector
if (document.getElementById("abilities")) {
    const AbilityIcons = document.querySelectorAll('.WarframeAbilityIcon');
    const AbilityVideos = document.querySelectorAll('.WarframeAbilityVideo');
    const AbilityDescriptions = document.querySelectorAll('.WarframeAbilityDescription');

    function syncAbilities(index) {
        AbilityIcons.forEach((elem, i) => elem.classList.toggle('is-active', index === i));
        AbilityVideos.forEach((elem, i) => {
            const isActive = index === i;
            elem.classList.toggle('is-active', isActive)
            if (isActive) {
                elem.currentTime = 0;
                elem.play();
            }
        });
        AbilityDescriptions.forEach((elem, i) => elem.classList.toggle('is-active', index === i));
    }
    AbilityIcons.forEach((icon, index) => {
        icon.addEventListener('click', () => {
           syncAbilities(index);
        });
    });
}

// Sortable list
if (document.getElementById('warframes')) {
    const SESSION_KEY_FILTERS = "kWarframeFilters";
    const WarframeListTitles = document.querySelectorAll('.WarframeListGrid-title');
    const WarframeSortFilter = document.querySelector('.WarframeListGrid-sort');
    const WarframeViewFilter = document.querySelector('.WarframeListGrid-view');
    const WarframeViewEmpty = document.querySelector('.WarframeListGrid-empty');
    const WarframeTiles = document.querySelectorAll('.WarframeListTile');
    const WarframeList = [];
    WarframeTiles.forEach((tile) => {
        WarframeList.push({
            id: tile.getAttribute('data-id'),
            element: tile,
            roles: tile.getAttribute('data-roles').split(','),
            standard: tile.getAttribute('data-type') === 'standard',
            primed: tile.getAttribute('data-type') === 'prime',
            proto: tile.getAttribute('data-type') === 'proto',
        });
    });

    function loadFilterState() {
        const state = sessionStorage.getItem(SESSION_KEY_FILTERS);
        if (state) {
            const {sort, view} = JSON.parse(state);
            WarframeSortFilter.value = sort;
            WarframeViewFilter.value = view;
            syncWarframes();
        }
    }
    function saveFilterState(state) {
        sessionStorage.setItem(SESSION_KEY_FILTERS, JSON.stringify(state));
    }

    function syncWarframes() {
        const sort = WarframeSortFilter.value;
        const view = WarframeViewFilter.value;
        let active = 0;
        WarframeList.forEach((warframe) => {
            let isActive = true;
            switch (view) {
                case 'primes':
                    isActive = warframe.primed;
                    break;
                case 'protoframes':
                    isActive = warframe.proto;
                    break;
                default:
                    isActive = warframe.standard;
                    break;
            }
            if (isActive) {
                if (sort !== 'all') {
                    isActive = warframe.roles.includes(sort);
                }
                if (isActive) active++;
            }
            warframe.element.classList.toggle('is-filtered', !isActive);
        });
        WarframeListTitles.forEach((title) => {
            title.classList.toggle('is-active', title.getAttribute('data-id') === view);
        });
        WarframeViewEmpty.classList.toggle('is-active', active < 1);
    }

    function filterWarframes() {
        const sort = WarframeSortFilter.value;
        const view = WarframeViewFilter.value;
        saveFilterState({sort, view});
        syncWarframes();
    }
    WarframeSortFilter.addEventListener('change', filterWarframes);
    WarframeViewFilter.addEventListener('change', filterWarframes);

    PageComponents.afterLoad(() => {
        loadFilterState();
    });
}
